@if (feedback.activeError(); as error) {
  <section class="global-error" role="alert" aria-live="assertive">
    <p class="message">{{ error.message }}</p>

    <div class="actions">
      @if (error.action && error.actionLabel) {
        <button type="button" class="action" (click)="runAction()">{{ error.actionLabel }}</button>
      }
      <button type="button" class="dismiss" (click)="dismiss()">Dismiss</button>
    </div>
  </section>
}
